import React, { useState, useRef } from "react";
import "../all css/advisorycounsilsection.css";
import Slider from "react-slick";
import {
  BsFillArrowLeftSquareFill,
  BsFillArrowRightSquareFill,
} from "react-icons/bs";
import UserInfo from "../aboutus/aboutus dialogbox/UserInfo";
import CustDialogBox from "../../components/custom dialogbox/CustDialogBox";
const info_icon = require("../../assets/aboutexplore/info_icon.png");
const counsil1 =  require("../../assets/counsil/anujS-circle.png");
const counsil2 =  require("../../assets/counsil/vasundha-circle.png");
const counsil3 =  require("../../assets/counsil/seema-circle.png");
const counsil4 =  require("../../assets/counsil/srikanth-circle.png");
const counsil5 =  require("../../assets/counsil/akhilesh.jpg");
const counsil6 =  require("../../assets/counsil/vasant.jpg");
const counsil7 =  require("../../assets/counsil/ashoo.jpg");
const counsil8 =  require("../../assets/counsil/singh.jpg");
const counsil9 =  require("../../assets/counsil/james.jpg");

const allAdvisoryCounsil = [
  {
    leaderImg: counsil1,
    leaderName: "ANUJ SAXENA",
    leaderSubname: "",
    personInfo:
      "Anuj is an Engineering graduate armed with MBA. He has close to two and a half decades of experience in Sales and Marketing including ten years in financial sectors. In his assignments he has overseen functions in General management, Sales/Marketing, Business Development, Commercial Excellence, Acquisition and Integration management, Channel Sales and Sales Strategy at ICICI Prudential and Aviva. Since 2019, he is an entrepreneur with knack of teaching finance. ",
    fbUserLink: "http://www.fb.com",
    linkUserLink: "https://www.linkedin.com/in/anuj-saxena-7277383/",
    twitterUserLink: "https://www.twitter.com",
  },
  {
    leaderImg: counsil2,
    leaderName: "Dr.Vasudha NeelMani",
    leaderSubname: "",
    personInfo:
      "Since 90's Vasudha along with developing leadership skills, advises and guides students to increase their confidence and help develop problem-solving skills. She had shared her experiences, life long learning and every thoughts in a bestselling book named GRATITUDE: The Purpose of Life",
    fbUserLink: "http://www.fb.com",
    linkUserLink: "https://www.linkedin.com/in/vasudha-neel-mani-72150b11",
    twitterUserLink: "https://www.twitter.com",
  },
  {
    leaderImg: counsil3,
    leaderName: "Seema Kumar",
    leaderSubname: "",
    personInfo:
      "With a career spanning over 35 years , Seema is an intuitive person who looks at possibilities rather than limitations. Her ability to communicate and take people along ensures a strong buy-in across. She demonstrates personal traits of Integrity and trust that allows her to build strong teams that get more done.",
    fbUserLink: "http://www.fb.com",
    linkUserLink: "https://www.linkedin.com/in/seema-kumar-36881364",
    twitterUserLink: "https://www.twitter.com",
  },
  {
    leaderImg: counsil4,
    leaderName: "Mr. C V Srikanth",
    leaderSubname: "",
    personInfo: `With a career spanning over 30 years across multinationals, C V Srikanth has driven ideas and innovative practices in leadership positions.
      He has a knack for an engaging audience when it comes to spiritual counseling, mentoring, coaching, and training creating value and a lasting impact across age groups.
      `,
    fbUserLink: "http://www.fb.com",
    linkUserLink: "https://bit.ly/31fD9pG",
    twitterUserLink: "https://www.twitter.com",
  },
  
  {
    leaderImg: counsil5,
    leaderName: "Prof. Akhilesh Kumar",
    leaderSubname: "",
    personInfo:
      "Akhilesh Kumar is an MBA, Ph.D. degree holder with distinguished experience of 40+years and held various advisory roles in the corporate/academic world. He was a professorat MIT(Massachusetts Institute of Technology) for 15 years and currently working as a Vice-Chancellor at AI Karim University.",
    fbUserLink: "http://www.fb.com",
    linkUserLink: "https://www.linkedin.com/in/akhilesh-kumar-4b649614/",
    twitterUserLink: "https://www.twitter.com",
  },
  {
    leaderImg: counsil6,
    leaderName: "Vasant Agarwal",
    leaderSubname: "",
    personInfo:
      "Vasant Agarwal is an eminent expert on Emotional Intelligence. He is a Director at Discover My Mind/Indian School Counsellor Association and the author of several successful books. Discover My Mind is a community of people dedicated to Emotional Intelligence and related sciences. He has been a speaker at international conferences across India. He is also a Senior Advisor to the International Training Federation.",
    fbUserLink: "http://www.fb.com",
    linkUserLink: "https://www.linkedin.com/in/vasant-agarwal/",
    twitterUserLink: "https://www.twitter.com",
  },
  {
    leaderImg: counsil7,
    leaderName: "Ashoo Kalra",
    leaderSubname: "",
    personInfo:
      "Ashoo Kalra, an accomplished academician with 25+ years of experience in establishing reputed chains of educational institutions and is also a member of ECDF. Being a teacher and leadership trainer, she has published various textbooks and has been an ambassador for DRR activities and SDG Choupal. Besides this, she is an Honorary Board member of UNACCC as well.",
    fbUserLink: "http://www.fb.com",
    linkUserLink: "http://www.fb.com",
    twitterUserLink: "https://www.twitter.com",
  },
  {
    leaderImg: counsil8,
    leaderName: "Brahmanand S Siingh",
    leaderSubname: "",
    personInfo:
      "Being the winner of Rex Karma veer Chakra Award, Brahmanand S Siingh is also a National Award-winning filmmaker, author, speaker, and mentor based out of Mumbai. He hasmade remarkable critically acclaimed films and feature films which continue to acclaimacross many platforms.",
    fbUserLink: "http://www.fb.com",
    linkUserLink: "http://www.fb.com",
    twitterUserLink: "https://www.twitter.com",
  },
  {
    leaderImg: counsil9,
    leaderName: "James Kerr",
    leaderSubname: "",
    personInfo:
      "James Kerr from Australia is a highly accomplished educationist with 30+ years of experience. He has headed educational institutions in various capacities. He is a very receptive consultant and his consultancy is fetched with clients from across the globe.",
    fbUserLink: "http://www.fb.com",
    linkUserLink: "http://www.fb.com",
    twitterUserLink: "https://www.twitter.com",
  },
];

function AdvisoryCounsil(props) {
  const customeSlider = React.useRef();

  const [toggleModal, setToggleModal] = useState(false);
  const [userInfo, setUserInfo] = useState(null);

  const gotoNext = () => {
    customeSlider.current.slickNext();
  };

  const gotoPrev = () => {
    customeSlider.current.slickPrev();
  };

  function handleCounsilInfo(e) {
    setUserInfo(e);
    setToggleModal(true);
  }

  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    initialSlide: 0,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },

      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const renderAllAdvisory = allAdvisoryCounsil.map(
    (perAdvisoryCounsil, index) => {
      return (
        <div
          key={Math.random()}
          data-wow-delay="5s"
          className={
            index % 2 === 0
              ? "wow  advisory_box1 animate__animated 	animate__infinite"
              : "wow  animate__animated advisory_box 	animate__infinite"
          }
        >
          <div
            className="advisory_box_container  animate__animated "
            onClick={() => handleCounsilInfo(perAdvisoryCounsil)}
          >
            <div className="info_btn_container">
              <img
                src={info_icon}
                alt="info_btn"
                className="info_btn_counsil_self"
              />
            </div>

            <div className="round_circle_advisory_img_container">
              <img
                src={perAdvisoryCounsil.leaderImg}
                alt="people_img"
                className="people_advisory_img"
              />
            </div>

            <p className="people_img_name_txt">
              {perAdvisoryCounsil.leaderName}
            </p>
          </div>
        </div>
      );
    }
  );
  return (
    <section className="advisory_counsil_main_container">
      <div className="advisory_counsil_under_container">
        <div className="title_and_extra_content_container">
          <div className="title_container">
            <div className="grey_bg_container" />
            <p className="title_text_advisory">
              Advisory <br />
              Council
            </p>
          </div>
          <div className="extra_adisory_container">
            <p className="extra_advisory_counsil_content">
              {/* The roots in a piece of classical Latin literature from 45 BC,
              making it over 2000 years old. Richard McClintock, a Latin
              professor at Hampden-Sydney College in Virginia, looked up one of
              the more obscure Latin words, sical literature, discovered the
              undoubtable. */}
            </p>
          </div>
        </div>

        <div className="slider_advisory_counsil_container">
          <Slider {...settings} ref={customeSlider}>
            {renderAllAdvisory}
          </Slider>
          <div className="yellow_container_horizontal">
            <div className="btn_left_right_advisory_container">
              <button
                className="prev_btn_advisoryt same_btn_advisory"
                onClick={() => gotoPrev()}
              >
                <BsFillArrowLeftSquareFill className="left_top_univercity_icon" />
              </button>

              <button
                className="next_btn_advisory same_btn_advisory"
                onClick={() => gotoNext()}
              >
                <BsFillArrowRightSquareFill className="left_top_univercity_icon" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <CustDialogBox
        dialogHeaderName=""
        open={toggleModal}
        onClose={() => {
          setToggleModal(false);
        }}
      >
        <UserInfo userDetails={userInfo} />
      </CustDialogBox>
    </section>
  );
}

export default AdvisoryCounsil;
